import { all, call } from '@redux-saga/core/effects';
import accountSagas from './account/account.sagas';
import appSettingsSagas from './appSettings/appSettings.sagas';
import controlsSagas from './controls/controls.sagas';
import explorePanelSagas from './explorePanel/explorePanel.sagas';
import itemDetailSagas from './itemDetail/itemDetail.sagas';
import queryPanelSagas from './queryPanel/queryPanel.sagas';
import queryResultsSagas from './queryResults/queryResults.sagas';
import { rostersSagas } from './rosters';

/**
 * Composite of all sagas within application. Add sagas here.
 */
export function* rootSaga(): Generator {
  yield all([
    call(accountSagas),
    call(appSettingsSagas),
    call(controlsSagas),
    call(queryPanelSagas),
    call(queryResultsSagas),
    call(itemDetailSagas),
    call(explorePanelSagas),
    call(rostersSagas),
  ]);
}

export default rootSaga;